<ckeditor
    #AngularEditor
    id="agpr_richTextEditor_element"
    [ngModel]="value"
    (ngModelChange)="valueChanged($event)"
    (ready)="initEditor($event)"
    [editor]="ckEditor"
    [config]="ckEditorConfig"
>
</ckeditor>
